<template>
  <div class="pb-2">
    <a
      class="d-flex btn pl-0"
      @click="
        ($parent.isExpand.document = !$parent.isExpand.document),
          $parent.checkExpandAll()
      "
    >
      <span class="pr-1">
        <i
          class="text-primary fas"
          :class="
            $parent.isExpand.document ? 'fa-angle-down' : 'fa-angle-right'
          "
          alt="angle-down"
        />
      </span>
      <h5 class="text-primary text-left">
        Document Information
        <span class="nowrap"
          >[{{ documents.length + resumeDocument.length }} Record{{
            documents.length + resumeDocument.length > 1 ? "s" : ""
          }}]</span
        >
      </h5>
    </a>
    <div v-if="$parent.isExpand.document">
      <div v-if="isEditable && !isJobSupplier">
        <DocumentUpload @upload="upload" />
      </div>
      <div v-if="isMobile">
        <h6
          v-if="resumeDocument.length || documents.length"
          class="pb-1 fw-600 pt-2 pb-2"
        >
          Documents :
        </h6>
        <h6 v-if="latestResume" class="text-primary">Latest Resume</h6>
        <div v-if="latestResume" class="pb-1 border-bottom pt-2 pb-2">
          <CRow class="pb-2">
            <CCol col="4" class="text-gray">Type</CCol>
            <CCol col="6" class="h6 fw-600">{{ latestResume.lable }}</CCol>
            <CCol col="0" class="text-gray">
              <CButton
                type="button"
                @click="fileDownload(latestResume, latestResume.document_id)"
                class="p-0"
              >
                <i class="fas fa-download"></i>
              </CButton>
            </CCol>
          </CRow>
          <CRow class="pb-2">
            <CCol col="4" class="text-gray">Name</CCol>
            <CCol col="6" class="text-black">{{ latestResume.name }}</CCol>
            <CCol col="0" class="text-black">
              <CButton type="button" @click="preview(latestResume)" class="p-0">
                <i class="fas fa-eye"></i>
              </CButton>
            </CCol>
          </CRow>
          <CRow class="pb-2">
            <CCol col="4" class="text-gray">Date of Upload</CCol>
            <CCol col="6" class="text-black">{{
              latestResume.updatedDate
            }}</CCol>
            <CCol col="0" class="text-black">
              <CButton
                type="button"
                @click="deleteDocuments(latestResume)"
                class="p-0"
              >
                <i class="fas fa-trash"></i>
              </CButton>
            </CCol>
          </CRow>
          <CRow class="pb-2">
            <CCol col="6" class="text-gray"
              >Description
              <a
                v-if="isEditable"
                class="hand-icon btn text-gray"
                @click="editInfo(latestResume)"
              >
                <i class="fas fa-pencil-alt"></i>
              </a>
            </CCol>
            <CCol col="6" class="text-black mt-2">
              {{ latestResume.comments ? latestResume.comments : "--" }}
            </CCol>
          </CRow>
        </div>
        <h6
          v-if="previousResume && previousResume.length"
          class="text-primary pt-2 f-13"
        >
          Previous Resume
        </h6>
        <div v-for="document in previousResume" :key="document.document_id">
          <div
            v-if="resumeDocument.length"
            class="pb-1 border-bottom pt-2 pb-2"
          >
            <CRow class="pb-2">
              <CCol col="4" class="text-gray">Type</CCol>
              <CCol col="6" class="h6 fw-600">{{ document.lable }}</CCol>
              <CCol col="0" class="text-gray">
                <CButton
                  type="button"
                  @click="fileDownload(document, document.document_id)"
                  class="p-0"
                >
                  <i class="fas fa-download"></i>
                </CButton>
              </CCol>
            </CRow>
            <CRow class="pb-2">
              <CCol col="4" class="text-gray">Name</CCol>
              <CCol col="6" class="text-black">{{ document.name }}</CCol>
              <CCol col="0" class="text-black">
                <CButton type="button" @click="preview(document)" class="p-0">
                  <i class="fas fa-eye"></i>
                </CButton>
              </CCol>
            </CRow>
            <CRow class="pb-2">
              <CCol col="4" class="text-gray">Date of Upload</CCol>
              <CCol col="6" class="text-black">{{ document.updatedDate }}</CCol>
              <CCol col="0" class="text-black">
                <CButton
                  type="button"
                  @click="deleteDocuments(document)"
                  class="p-0"
                >
                  <i class="fas fa-trash"></i>
                </CButton>
              </CCol>
            </CRow>
            <CRow class="pb-2">
              <CCol col="6" class="text-gray"
                >Description
                <a
                  v-if="isEditable"
                  class="hand-icon btn text-gray"
                  @click="editInfo(document)"
                >
                  <i class="fas fa-pencil-alt"></i>
                </a>
              </CCol>
              <CCol col="6" class="text-black mt-2">
                {{ document.comments ? document.comments : "--" }}
              </CCol>
            </CRow>
          </div>
        </div>
        <h6
          v-if="
            previousResume &&
            previousResume.length &&
            documents &&
            documents.length
          "
          class="text-primary pt-2 f-13"
        >
          Other Documents
        </h6>
        <div v-for="document in documents" :key="document.document_id">
          <div class="pb-1 border-bottom pt-2 pb-2">
            <CRow class="pb-2">
              <CCol col="4" class="text-gray">Type</CCol>
              <CCol col="6" class="h6 fw-600">{{ document.lable }}</CCol>
              <CCol col="0" class="text-gray">
                <CButton
                  type="button"
                  @click="fileDownload(document, document.document_id)"
                  class="p-0"
                >
                  <i class="fas fa-download"></i>
                </CButton>
              </CCol>
            </CRow>
            <CRow class="pb-2">
              <CCol col="4" class="text-gray">Name</CCol>
              <CCol col="6" class="text-black">{{ document.name }}</CCol>
              <CCol col="0" class="text-black">
                <CButton type="button" @click="preview(document)" class="p-0">
                  <i class="fas fa-eye"></i>
                </CButton>
              </CCol>
            </CRow>
            <CRow class="pb-2">
              <CCol col="4" class="text-gray">Date of Upload</CCol>
              <CCol col="6" class="text-black">{{ document.updatedDate }}</CCol>
              <CCol col="0" class="text-black">
                <CButton
                  type="button"
                  @click="deleteDocuments(document)"
                  class="p-0"
                >
                  <i class="fas fa-trash"></i>
                </CButton>
              </CCol>
            </CRow>
            <CRow class="pb-2">
              <CCol col="6" class="text-gray"
                >Description
                <a
                  v-if="isEditable"
                  class="hand-icon btn text-gray"
                  @click="editInfo(document)"
                >
                  <i class="fas fa-pencil-alt"></i>
                </a>
              </CCol>
              <CCol col="6" class="text-black mt-2">
                {{ document.comments ? document.comments : "--" }}
              </CCol>
            </CRow>
          </div>
        </div>
        <div v-if="!documents.length">
          <p v-if="resumeDocument.length" class="text-center text-gray pt-3">
            No Further Documents Found
          </p>
          <p v-else class="text-center text-gray">No Documents Found</p>
        </div>
        <p
          v-if="isCandidateRole"
          class="text-primary text-center pt-3 h6"
          @click="navigateToEditProfile()"
        >
          (Upload New Documents)
        </p>
      </div>
      <div v-else>
        <div
          class="
            d-flex
            align-items-center
            documentScrolling
            document-table
            border
          "
        >
          <table class="table">
            <thead>
              <tr>
                <th class="nowrap w-25">Type</th>
                <th class="nowrap">Description</th>
                <th class="nowrap">Name</th>
                <th class="nowrap">Date Uploaded</th>
                <th class="nowrap">Download</th>
                <th class="nowrap">Preview</th>
                <th v-if="isEditable" class="nowrap">Delete</th>
              </tr>
            </thead>
            <tbody class="text-black">
              <tr v-if="latestResume">
                <td>
                  {{ latestResume.lable || "--" }}
                  <span
                    v-if="latestResume.lable"
                    class="data text-primary h6 f-13"
                    >{{ `(Latest)` }}</span
                  >
                </td>
                <td class="text-justify">
                  {{ latestResume.comments ? latestResume.comments : "--" }}
                  <a
                    v-if="isEditable"
                    class="hand-icon btn p-0 float-right pr-3"
                    @click="editInfo(latestResume)"
                  >
                    <i class="fas fa-pencil-alt"></i>
                  </a>
                </td>
                <td class="candidate-file-name">
                  {{ latestResume.name || "--" }}
                </td>
                <td>{{ latestResume.updatedDate }}</td>
                <td>
                  <button
                    :disabled="
                      disabledBtnDocID.includes(latestResume.document_id)
                    "
                    class="hand-icon action-button"
                    v-if="latestResume && latestResume.link"
                    @click="
                      fileDownload(latestResume, latestResume.document_id)
                    "
                  >
                    <i class="fas fa-download ml-3"></i>
                  </button>
                </td>
                <td>
                  <a
                    class="hand-icon"
                    v-if="latestResume && latestResume.link"
                    @click="preview(latestResume)"
                  >
                    <i class="fas fa-eye ml-3"></i>
                  </a>
                </td>
                <td v-if="isEditable">
                  <a
                    class="hand-icon"
                    v-if="latestResume && latestResume.link"
                    @click="deleteDocuments(latestResume)"
                  >
                    <i class="fas fa-trash ml-3"></i>
                  </a>
                </td>
              </tr>
              <tr v-if="previousResume && previousResume.length">
                <td colspan="7" class="p-1">
                  <p class="text-center text-primary h6 m-0 p-0 f-13">
                    Previous version(s) of CV/Resume
                  </p>
                </td>
              </tr>
              <tr v-for="data in previousResume" :key="data.document_id">
                <td>{{ data.lable || "--" }}</td>
                <td class="text-justify">
                  {{ data.comments ? data.comments : "--" }}
                  <a
                    v-if="isEditable"
                    class="hand-icon btn p-0 float-right pr-3"
                    @click="editInfo(data)"
                  >
                    <i class="fas fa-pencil-alt"></i>
                  </a>
                </td>
                <td class="candidate-file-name">
                  <span> {{ data.name || "--" }}</span>
                </td>
                <td>{{ data.updatedDate }}</td>
                <td>
                  <button
                    :disabled="disabledBtnDocID.includes(data.document_id)"
                    class="hand-icon action-button"
                    v-if="data && data.link"
                    @click="fileDownload(data, data.document_id)"
                  >
                    <i class="fas fa-download ml-3"></i>
                  </button>
                </td>
                <td>
                  <a
                    class="hand-icon"
                    v-if="data && data.link"
                    @click="preview(data)"
                  >
                    <i class="fas fa-eye ml-3"></i>
                  </a>
                </td>
                <td v-if="isEditable">
                  <a
                    class="hand-icon"
                    v-if="data && data.link"
                    @click="deleteDocuments(data)"
                  >
                    <i class="fas fa-trash ml-3"></i>
                  </a>
                </td>
              </tr>
              <tr
                v-if="
                  previousResume &&
                  previousResume.length &&
                  documents &&
                  documents.length
                "
              >
                <td colspan="7" class="p-1">
                  <p class="text-center text-primary h6 m-0 p-0 f-13">
                    Other Documents
                  </p>
                </td>
              </tr>
              <tr v-for="data in documents" :key="data.document_id">
                <td>{{ data.lable || "--" }}</td>
                <td class="text-justify">
                  {{ data.comments ? data.comments : "--" }}
                  <a
                    v-if="isEditable"
                    class="hand-icon btn p-0 float-right pr-3"
                    @click="editInfo(data)"
                  >
                    <i class="fas fa-pencil-alt"></i>
                  </a>
                </td>
                <td class="candidate-file-name">{{ data.name || "--" }}</td>
                <td>{{ data.updatedDate }}</td>
                <td>
                  <button
                    :disabled="disabledBtnDocID.includes(data.document_id)"
                    class="hand-icon action-button"
                    v-if="data && data.link"
                    @click="fileDownload(data, data.document_id)"
                  >
                    <i class="fas fa-download ml-3"></i>
                  </button>
                </td>
                <td>
                  <a
                    class="hand-icon"
                    v-if="data && data.link"
                    @click="preview(data)"
                  >
                    <i class="fas fa-eye ml-3"></i>
                  </a>
                </td>
                <td v-if="isEditable">
                  <a
                    class="hand-icon"
                    v-if="data && data.link"
                    @click="deleteDocuments(data)"
                  >
                    <i class="fas fa-trash ml-3"></i>
                  </a>
                </td>
              </tr>
              <tr>
                <td v-if="!documents.length" colspan="7">
                  <p
                    v-if="resumeDocument.length"
                    class="text-center text-gray h6"
                  >
                    No Further Documents to Preview
                  </p>
                  <p v-else class="text-center text-gray h6">
                    No Documents to Preview
                  </p>
                  <h6
                    v-if="isCandidateRole"
                    colspan="7"
                    class="text-center"
                    style="cursor: pointer"
                  >
                    <a class="text-primary" @click="navigateToEditProfile()">
                      (Upload New Documents)
                    </a>
                  </h6>
                </td>
              </tr>
              <tr v-if="documents.length">
                <td colspan="7">
                  <h6
                    v-if="isCandidateRole"
                    colspan="7"
                    class="text-center"
                    style="cursor: pointer"
                  >
                    <a class="text-primary" @click="navigateToEditProfile()">
                      (Upload New Documents)
                    </a>
                  </h6>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <PreviewModal
        :modalTitle="previewModal.modalTitle"
        :modalColor="previewModal.modalColor"
        :isShowPopup="previewModal.isShowPopup"
        :buttons="previewModal.buttons"
        :modalCallBack="modalCallBack"
        :isPreview="previewModal.isPreview"
        :iframe="iframe"
        :size="previewModal.size"
        :closeOnBackdrop="previewModal.closeOnBackdrop"
        v-if="previewModal.isShowPopup"
      />
      <DocumentInfoEdit
        :documentInfo="EditModal.documentInfo"
        :isShowPopup="EditModal.isShowPopup"
        @modalCallBack="documentInfoModalCallBack"
        v-if="EditModal.isShowPopup"
      />
      <Modal
        :modalTitle="deleteConfirmModal.modalTitle"
        :modalColor="deleteConfirmModal.modalColor"
        :modalContent="deleteConfirmModal.modalContent"
        :isShowPopup="deleteConfirmModal.isShowPopup"
        :buttons="deleteConfirmModal.buttons"
        :modalCallBack="deletemodalCallBack"
        :closeOnBackdrop="false"
        v-if="deleteConfirmModal.isShowPopup"
      />
      <QualificationMappingModal
        :isShowPopup="linkDocument.isShowPopup"
        :document_type_id="linkDocument.document_type_id"
        :candidate_document_id="linkDocument.candidate_document_id"
        :label="linkDocument.label"
        :modalTitle="linkDocument.modalTitle"
        :modalContent="linkDocument.modalContent"
      />
    </div>
  </div>
</template>
<script>
import PreviewModal from "@/components/reusable/PreviewModal";
import pdf from "vue-pdf";
import { BASE_URL } from "@/service_urls";
import DocumentInfoEdit from "@/containers/CandidateDetailsTalentFind/EditForm/DocumentInfoEdit";
import { mapActions, mapGetters } from "vuex";
import { Role, getScope } from "@/helpers/helper";
import DocumentUpload from "@/containers/CandidateDetailsTalentFind/EditForm/DocumentUpload";
import Modal from "@/components/reusable/Modal";
import QualificationMappingModal from "@/containers/CandidateProfile/QualificationMappingModal.vue";
import isJobSupplier from "@/mixins/isJobSupplier";
import { appendAccessToken, generateFullUrlWithToken } from "../../../helpers/helper";
export default {
  mixins: [isJobSupplier],
  props: {
    resumeDocument: { type: Array, default: () => [] },
    documents: { type: Array, default: () => [] },
    disabledBtnDocID: { type: Array, default: () => [] },
    profile: { type: Object, default: () => null },
    isMobile: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    PreviewModal,
    DocumentInfoEdit,
    DocumentUpload,
    Modal,
    QualificationMappingModal,
  },
  data() {
    return {
      iframe: {
        src: "",
        loaded: false,
        isImg: false,
        pdf: {
          ispdf: false,
          src: "",
          numPages: undefined,
          addContentClasses: "",
        },
      },
      previewModal: {
        modalColor: "primary",
        modalTitle: "Document Preview",
        isShowPopup: false,
        buttons: ["OK"],
        isPreview: false,
        size: "lg",
        closeOnBackdrop: false,
      },
      EditModal: {
        isShowPopup: false,
        documentInfo: null,
      },
      Role,
      currentUserRole: getScope(),
      deleteConfirmModal: {
        modalColor: "danger",
        modalTitle: "NOTIFICATION",
        modalContent: "",
        isShowPopup: false,
        buttons: ["Cancel", "Confirm"],
      },
      candidate_document: {},
      linkDocument: {
        label: "",
        modalTitle: "",
        modalContent: "",
        candidate_document_id: null,
        isShowPopup: false,
        document_type_id: null,
      },
      isShowPrevious: false,
      generateFullUrlWithToken
    };
  },
  computed: {
    ...mapGetters([
      "getUserId",
      "uploaded",
      "lastUploadedDocs",
      "isUKMainAgency",
      "currentUserType",
    ]),
    isEditable() {
      return (
        ([Role.customerAdmin, Role.customerRecruiter].includes(
          this.currentUserType?.code || this.currentUserRole
        ) &&
          !this.isJobSupplier) ||
        false
      );
    },
    latestResume() {
      return _.maxBy(this.resumeDocument, "version_no");
    },
    previousResume() {
      return _.filter(
        this.resumeDocument,
        (doc) => this.latestResume?.document_id != doc.document_id
      );
    },
    isCustomerAdmin() {
      return this.currentUserRole === this.Role.customerAdmin;
    },
    isCandidateRole() {
      return (
        this.currentUserRole === Role.customerCandidate ||
        this.currentUserRole === Role.systemCandidate
      );
    },
  },
  methods: {
    ...mapActions([
      "updateDocument",
      "uploadPhoto",
      "uploadResume",
      "updateCandidateInfoByID",
      "deleteDocument",
      "fetchQualification",
      "fetchLicense",
      "downloadDocument",
    ]),
    navigateToEditProfile() {
      this.$store.state.candidate.block = 2;
      this.$router.push("/profile#section-2");
    },
    // fileDownload(data, docId) {
    //   this.$emit("fileDownload", data, docId);
    // },
    fileDownload(data, docId) {
      let { link, name: document_name } = data;
      let url = link.replace("/api/v1/", "");
      url = appendAccessToken(url)
      this.downloadDocument({ url, document_name });
    },
    showPreview(data) {
      const { link } = data;
      //  const _baseUrl = BASE_URL;
      //  const _base_domain = _baseUrl.substring(0, _baseUrl.indexOf("/api"));
      // const _base_domain = "https://" + window.location.host;
      return generateFullUrlWithToken(`${link}`);
    },
    preview(data) {
      data.link_to_document = this.showPreview(data);
      var _baseUrl = BASE_URL;
      // var _base_domain = _baseUrl.substring(0, _baseUrl.indexOf("/api"));
      var _base_domain = "https://" + window.location.host;
      if (["PNG", "JPG", "JPEG", "GIF"].includes(data?.document_ext)) {
        this.iframe.loaded = false;
        this.iframe.ispdf = false;
        this.iframe.isImg = true;
        this.iframe.src = data.link_to_document;
        this.previewModal.isPreview = true;
        this.previewModal.isShowPopup = true;
      } else if (data?.document_ext === "PDF") {
        this.iframe.isImg = false;
        this.iframe.loaded = false;
        this.iframe.pdf.ispdf = true;
        this.iframe.pdf.src = pdf.createLoadingTask(data.link_to_document);
        setTimeout(() => {
          this.iframe.pdf.src.promise.then((pdf) => {
            this.iframe.pdf.numPages = pdf.numPages;
          });
        }, 100);
        this.previewModal.isPreview = true;
        this.previewModal.isShowPopup = true;
      } else if (
        ["TXT", "EPS", "TIF", "TIFF", "RAW"].includes(data?.document_ext)
      ) {
        this.showToast({
          class: "bg-danger text-white",
          message: "The selected file type is not available for Preview.",
        });
        this.iframe.src = "";
        this.iframe.loaded = false;
        this.iframe.isImg = false;
        this.iframe.pdf.ispdf = false;
        this.previewModal.isPreview = false;
        this.previewModal.isShowPopup = false;
      } else {
        this.iframe.isImg = false;
        this.iframe.ispdf = false;
        this.iframe.loaded = true;
        this.iframe.src =
          "https://view.officeapps.live.com/op/embed.aspx?src=" + data.link_to_document;
        this.previewModal.isPreview = true;
        this.previewModal.isShowPopup = true;
      }
    },
    modalCallBack(action) {
      this.previewModal.isPreview = false;
      this.previewModal.isShowPopup = false;
      this.iframe.src = "";
      this.iframe.loaded = false;
      this.iframe.isImg = false;
      this.iframe.pdf.ispdf = false;
    },
    editInfo(data) {
      this.EditModal.isShowPopup = true;
      this.EditModal.documentInfo = data;
      return false;
    },
    documentInfoModalCallBack(action, data) {
      this.EditModal.isShowPopup = false;
      if (action == true) {
        let payload = {
          candidate_document_id: this.EditModal.documentInfo.document_id,
          comments: data,
        };
        this.updateDocument(payload);
      }
    },
    upload(payload) {
      const document_type = payload.document_type || 1;
      const { customer_uid, candidate_uid } = this.profile;
      const user_id = this.getUserId;
      if (payload && payload.name) {
        if (payload.isPhotoUpload) {
          this.uploadPhoto({
            customer_uid,
            candidate_uid,
            user_id,
            [payload.name]: payload.value,
            document_type,
            ["fileName"]: payload.document_name,
            blobData: payload.blobData,
          }).then((res) => {
            if (res) {
              const { data } = res;
              const { is_version_doc_type,document_type_id } = data;
              if(document_type_id === 1 || is_version_doc_type === false){
                //Append Document
                this.$store.commit("APPEND_DOCUMENT",data);
              }else{
                //Override Document
                this.$store.commit("OVERRIDE_DOCUMENT",data);
              }
              if(document_type === 2){
                this.updateCandidateInfoByID(candidate_uid);
              }
            }
          });
        } else {
          this.uploadResume({
            customer_uid,
            candidate_uid,
            user_id,
            [payload.name]: payload.value,
            document_type,
          }).then((res) => {
            if (res) {
              const { data } = res;
              const { is_version_doc_type,document_type_id } = data;
              if(document_type_id === 1 || is_version_doc_type === false){
                //Append Document
                this.$store.commit("APPEND_DOCUMENT",data);
              }else{
                //Override Document
                this.$store.commit("OVERRIDE_DOCUMENT",data);
              }
            }
          });
        }
      }
    },
    deleteDocuments(data) {
      this.deleteConfirmModal.modalContent = `Do you want to delete this document - ${data.name} ?`;
      this.candidate_document = data;
      this.deleteConfirmModal.isShowPopup = true;
    },
    deletemodalCallBack(action) {
      if (action === "Confirm") {
        let document = this.candidate_document;
        this.deleteDocument(document.document_id).then((res) => {
          if (document.document_type_id == 12) this.fetchQualification();
          if (document.document_type_id == 9) this.fetchLicense();
        });
      }
      this.candidate_document = {};
      this.deleteConfirmModal.isShowPopup = false;
    },
  },
  watch: {
    uploaded() {
      if (this.uploaded) {
        // const { candidate_uid } = this.profile;
        // this.updateCandidateInfoByID(candidate_uid);
        this.linkDocument.document_type_id =
          this.lastUploadedDocs?.document_type_id;
        this.linkDocument.label = this.lastUploadedDocs?.document_name;
        this.linkDocument.candidate_document_id =
          this.lastUploadedDocs?.candidate_document_id;
        if (this.lastUploadedDocs?.document_type_id == 9) {
          this.linkDocument.modalTitle = "License Mapping";
          this.linkDocument.modalContent =
            "Select the License to be mapped with the Document:";
          this.linkDocument.isShowPopup = true;
        } else if (this.lastUploadedDocs?.document_type_id == 12) {
          this.linkDocument.modalTitle = "Qualification Mapping";
          this.linkDocument.modalContent =
            "Select the Qualification to be mapped with the Document:";
          this.linkDocument.isShowPopup = true;
        }
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.preview {
  .iframeclass {
    width: 75%;
  }
  .modalPdfContent {
    height: 350px !important;
    overflow-y: scroll;
  }
  .wrapper {
    -webkit-overflow-scrolling: touch;
    -moz-overflow-scrolling: touch;
    -ms-overflow-scrolling: touch;
  }
  @media all and (max-width: 480px) {
    .iframeclass {
      width: auto;
    }
  }
}
.action-button {
  width: 14px;
  height: 14px;
  border: 0;
  background: transparent;
  padding: 0;
  outline: none;
}
.hand-icon {
  color: #3c4b64;
  cursor: pointer;
}
.f-13 {
  font-size: 13px;
}
</style>
